import axios from 'axios';
import config from '../config';


function getCookie(cookieName) {
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    
    if (cookie.startsWith(cookieName + '=')) {
      
      return cookie.substring(cookieName.length + 1);
    }
  }

  return null;
}



axios.defaults.baseURL = config.BASE_URL;
axios.defaults.withCredentials = true;


axios.interceptors.request.use(function (axios_config) {
  axios_config.headers.authorization = localStorage.getItem('token') || '------';
  axios_config.headers.bfp = getCookie('bfp');
  axios_config.headers.type = localStorage.getItem('type')
  return axios_config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

axios.interceptors.response.use(function (response) {
  const newToken = response.headers['x-new-token'];
  if (newToken) localStorage.setItem('token', newToken);
  return response;
}, function (error) {
  return Promise.reject(error);
});

export default axios